import appNotificationService from '@core/services/utils/appNotificationService';
import {useAuthStore} from '@core/stores/authStore';
import EventBus from '@core/services/utils/appEventBusService';
import BusEnum from '@core/enums/BusEnum';
import AxiosService from '@core/services/app/axiosService';
import appConsoleService from '@core/services/utils/appConsoleService';
import authHeader from '@core/services/app/authHeader';
import NavigationService from "@core/services/utils/appNavigationService";
import AppPasskeyService from "@core/services/app/appPasskeyService";

class AuthService {

  getStoreInstance() {
    if (!this.store) {
      this.store = useAuthStore()
      EventBus.on(BusEnum.PROFILE_IMAGE_UPDATE, data=>{
        this.store.updateProfilImage(data)
      })
    }
    return this.store
  }

  //////////////////////////////////////////////////

  async authWithPassword(username, password) {
    try {
      let response = await AxiosService.post("/login", {username : username, password:password}) // Don't put header !!!!
      if(response && response.data && response.data.user) {
        appNotificationService.pushInfo(response.data.message)
        this.getStoreInstance().login(response.data.user)
        return response.data.user
      }
      return null
    } catch (error) {
      throw error
    }
  }

  async retrievePassword(username) {
    try {
      let response = await AxiosService.post("/appPassword/updatePassword", {username : username},{headers: authHeader()});
      appNotificationService.pushInfo(response.data.message)
    } catch (error) {
      appNotificationService.pushError(error)
    }
  }

  async registerUser(data) {
    try {
      let response = await AxiosService.post("/auth/registerUser", {
        data: data
      });
      appNotificationService.pushInfo(response.data.message)
      return response.data.user
    } catch (error) {
      appNotificationService.pushError(error.message)
    }
  }

  /**
   * Rafraîchit les autorités de l'utilisateur courant depuis le backend, SANS
   * re-login. À appeler après un changement de profil côté serveur (ex.
   * candidat → recruteur via /sosRecruiter/enroll) : sinon authStore garde les
   * autorités du login (périmées) et l'UI gated par hasPermission(...) ne
   * s'adapte pas (widget de bascule recruteur, etc.). Fusionne dans authStore
   * en préservant l'access_token. Best-effort : silencieux en cas d'échec.
   * @returns {string[]|null} les autorités fraîches, ou null si échec.
   */
  async refreshCurrentUser() {
    try {
      const res = await AxiosService.get('/appUser/currentUser', { headers: authHeader() });
      const authorities = res?.data?.authorities;
      if (Array.isArray(authorities)) {
        this.getStoreInstance().setAuthorities(authorities);
        return authorities;
      }
      return null;
    } catch (error) {
      appConsoleService.error('AuthService.refreshCurrentUser', error);
      return null;
    }
  }

  async disconnect() {
    // SOS candidate sessions are also backed by a long-lived, httpOnly
    // `sos_refresh_token` cookie. Because it's httpOnly, the SPA cannot clear
    // it — only the backend can. If we skip this, the cookie survives logout
    // and the next visit to /candidate-auth silently auto-logs the user back
    // in (even after they revoked their device). Best-effort + withCredentials;
    // it's a harmless no-op for non-candidate users (no such cookie to revoke).
    try {
      await AxiosService.post('/sosCandidateAuth/candidateLogout', {}, { withCredentials: true })
    } catch (e) {
      appConsoleService.error('AuthService.disconnect.candidateLogout', e)
    }
    this.getStoreInstance().logout()
    // Pas de relance automatique de la biométrie juste après une déconnexion volontaire.
    AppPasskeyService.markLoggedOut()
    await NavigationService.goToLogin()
  }

}

export default new AuthService();
